import React, { useEffect } from 'react';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

const About = (props) => {
  const { t } = props

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <div className=" content-container cancel-done-section pages-about font10">
      <div className="page-title font20">
        {i18next.language == 'es' ? (
          <span>
            Acerca de<span className="bold-text">&nbsp;kupos.cl</span>
          </span>
        ) : (
          <span>
            About<span className="bold-text">&nbsp;kupos.cl</span>
          </span>
        )}
      </div>

      {/* <div className="about-head-sections">
          <div className="about-head-section">
            <div className="head-img">
              <img src="/images/our_mission.svg" />
            </div>
            <div>
              <div className="about-head-section-title para font12">
                Nuestra <span className="bold-text">misión</span>
              </div>
              <div className="about-head-section-desc">
                Ofrecer a los clientes la más amigable, única y completa experiencia de viaje y
                transporte con el poder de la tecnología.
              </div>
            </div>
          </div>
          <div className="about-head-section">
            <div className="head-img">
              <img src="/images/our_vision.svg" />
            </div>
            <div>
              <div className="about-head-section-title para font12">
                Nuestra <span className="bold-text">visión</span>
              </div>
              <div className="about-head-section-desc">
                Ser una empresa dedicada y centrada en el consumidor, creando y facilitando la
                experiencia de viaje y transporte en el día a día.
              </div>
            </div>
          </div>
        </div> */}

      <div>
        <div className="para">
          {/* <span className="image-inside-text">
              <img src="/images/kupos_logo_2.png" alt="" />
            </span> &nbsp;*/}
          <span className="bold-text">{t('ABOUT_US.ABOUT_1.BOLD')}</span>
          <span>{t('ABOUT_US.ABOUT_1.NORMAL')}</span>
        </div>
        <div className="para">
          <span>{t('ABOUT_US.ABOUT_2')}</span>
        </div>
        <div className="para">
          <span className="bold-text">{t('ABOUT_US.ABOUT_3.BOLD')}</span>
          <span>{t('ABOUT_US.ABOUT_3.NORMAL')}</span>
        </div>
        {/* <div className="para">
            <span className="image-inside-text">
              <img src="/images/kupos_logo_2.png" alt="" />
            </span>
            &nbsp;nos hemos preocupado por mantener nuestro servicio al mayor estándar posible, y
            para esto contamos con un equipo multidisciplinario de profesionales que trabaja a
            diario para mejorar constantemente nuestra tecnología, así como para ofrecer a los
            viajeros información y ofertas reales que les generen el máximo nivel de satisfacción.
          </div>
          <div className="para">
            Hemos recibido el apoyo y reconocimiento de grandes empresas y organizaciones como
            Microsoft Chile e Imagine Business Lab y, lo que nos ha permitido mantener nuestros
            estándares de calidad y convertirnos en la mejor alternativa a la hora de viajar en bus.
          </div>
          <div className="para">
            En Chile y próximamente en toda América Latina, kupos.cl es la manera más fácil de
            comprar pasajes de bus.
          </div> */}

        <div className="about-mid-heading">
          <span>{t('ABOUT_US.KEY_OFFERINGS.NORMAL')}</span>{' '}
          <span className="bold-text">{t('ABOUT_US.KEY_OFFERINGS.BOLD')}</span>
        </div>

        <div className="about-head-mid-sections">
          <div className="about-head-mid-section">
            <div className="head-img">
              <img src="/images/icons/home/icon_bus.png" alt={t('TRANSLATIONS.BUS')} />
            </div>
            <div>
              <div className="about-head-section-title para font12">
                <span className="bold-text">PasajeBus.com</span>
              </div>
              <div className="about-head-section-desc">
                <span>{t('ABOUT_US.PASAJEBUS')}</span>
              </div>
            </div>
          </div>
          <div className="about-head-mid-section">
            <div className="head-img">
              <img src="/images/icons/home/icon_car.png" alt={t('TRANSLATIONS.CAR')} />
            </div>
            <div>
              <div className="about-head-section-title para font12">
                <span className="bold-text">kupospool</span>
              </div>
              <div className="about-head-section-desc">
                <span>{t('ABOUT_US.KUPOS_POOL')}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="about-head-mid-sections">
          <div className="about-head-mid-section">
            <div className="head-img">
              <img src="/images/money_coins.svg" alt={t('TRANSLATIONS.MONEY_COINS')} />
            </div>
            <div>
              <div className="about-head-section-title para font12">
                <span className="bold-text">kupospay</span>
              </div>
              <div className="about-head-section-desc">
                <span>{t('ABOUT_US.KUPOS_PAY')}</span>
              </div>
            </div>
          </div>
          <div className="about-head-mid-section">
            <div className="head-img">
              <img
                src="/images/icons/home/height_bus.png"
                alt={t('TRANSLATIONS.HEIGHT_BUS')}
              />
            </div>
            <div>
              <div className="about-head-section-title para font12">
                <span className="bold-text">kuposgo</span>
              </div>
              <div className="about-head-section-desc">
                <span>{t('ABOUT_US.KUPOS_GO')}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="kupos-card video-card">
          <div className="font13 video-title">
            Videos de <span className="bold-text">kupos.cl</span>
          </div>
          <div className="video-div">
            <img
              className="thumbnail"
              src="/images/icons/home/home-banner.png"
              alt={t('TRANSLATIONS.BANNER_IMG')}
            />
            <img
              className="play-icon"
              src="/svgs/video-play.svg"
              alt={t('TRANSLATIONS.VIDEO')}
            />
            <div className="video-title font11">kupos.cl ¡Nueva plataforma de transporte!</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withTranslation('common')(About);



// WEBPACK FOOTER //
// ./src/features/pages/About.js